import ServicesList from '../components/Services/ServicesList';

export default function ServicesPage({ setActiveTab }) {
  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Our Comprehensive Services</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">We provide end-to-end technology solutions tailored to businesses across World</p>
        </div>
        
        <ServicesList setActiveTab={setActiveTab} />
        
        <div className="mt-16 bg-gray-50 rounded-lg p-8">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Need a Custom Solution?</h3>
              <p className="text-gray-600 mb-6">We specialize in building bespoke software that addresses unique business challenges.</p>
              <button 
                onClick={() => setActiveTab('contact')} 
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition duration-300"
              >
                Discuss Your Project
              </button>
            </div>
            <div className="md:w-1/2 flex justify-center">
              <img 
                src="https://img.freepik.com/free-photo/view-male-engineer-work-engineers-day-celebration_23-2151615006.jpg?t=st=1746837560~exp=1746841160~hmac=5045ab64ddc43ced638bb3a04f7da0ad42f7df367d05bd5092ab1ac021859114&w=996" 
                alt="Team collaboration" 
                className="rounded-lg shadow-md w-full max-w-md"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}